import { FC, ReactNode } from "react";
import SvgInbox from "../icons/Inbox";
import ErrorText from "./ErrorText";
import Icon from "./Icon";
import LoadingSpinner from "./LoadingSpinner";
import styles from "./TableStatus.module.css";

interface TableEmptyStateProps {
  message: ReactNode;
  icon?: ReactNode;
}

export const TableEmptyState: FC<TableEmptyStateProps> = ({ message, icon }: TableEmptyStateProps) => (
  <div className={styles.emptyState}>
    <span className={styles.emptyStateIcon}>{icon ?? <Icon glyph={SvgInbox} />}</span>
    <span>{message}</span>
  </div>
);

export const TableLoadingState: FC = () => (
  <div className={styles.loadingState}>
    <LoadingSpinner />
  </div>
);

interface TableErrorStateProps {
  message: string;
}

export const TableErrorState: FC<TableErrorStateProps> = ({ message }: TableErrorStateProps) => (
  <div className={styles.errorState}>
    <ErrorText text={message} />
  </div>
);
